module.exports = __webpack_public_path__ + "static/fipcpinkblossom3-f87d1b2d564f665c47bca52fe4ff87a6.jpeg";